import { render, staticRenderFns } from "./BillingPageTab.vue?vue&type=template&id=34e3fdf6&scoped=true&"
import script from "./BillingPageTab.vue?vue&type=script&lang=ts&"
export * from "./BillingPageTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e3fdf6",
  null
  
)

export default component.exports